import styled from '@emotion/styled'
import { colors } from 'utils/colors'
import { BREAKPOINTS, pxToRem } from 'utils/styled'
import { DataEncrypted } from '../auth/DataEncrypted'
import { Block } from '../Block'
import { Stack } from '../Stack'
import { Caption, Title } from '../Typography'
import { EnterpriseContactForm } from 'components/content/contact/contactForm/ContactForm'
import { formatTextWithLineBreaks } from 'utils/text/formatTextWithLineBreaks'

import { IContentfulRichText } from 'api/contentful/contentful.types'
import { ContentfulContent } from 'components/content/contentfulContent/ContentfulContent'
import { Anchor } from 'components/Anchor'

const SWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 0 ${pxToRem(130)}rem;

  @media ${BREAKPOINTS.LG.max} {
    grid-gap: 2rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 1fr;
    grid-gap: 5rem;
  }
`

const SBusinessRegisterContainer = styled.div`
  background-color: ${colors.gray[50]};
  padding: 6rem 0;
`

type BusinessRegisterProps = {
  caption?: string
  title?: string
  description?: IContentfulRichText
}

export function BusinessRegister({ caption, title, description }: BusinessRegisterProps) {
  return (
    <SBusinessRegisterContainer>
      <Block>
        <SWrapper>
          <Stack space="2rem" css={{ marginTop: '1rem' }}>
            <Caption>{caption}</Caption>
            <Stack space="1.5rem">
              <Title variant="h3">{formatTextWithLineBreaks(title)}</Title>

              <ContentfulContent data={description} />
            </Stack>
          </Stack>
          <Stack space="1.5rem" css={{ alignItems: 'center' }}>
            <Anchor id="contact" />

            <EnterpriseContactForm />
            <DataEncrypted />
          </Stack>
        </SWrapper>
      </Block>
    </SBusinessRegisterContainer>
  )
}
